import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IoEyeOutline } from "react-icons/io5";
import { ToastContainer, toast } from "react-toastify";
import { selectMode } from "../../../service/slice/ThemeSlice";
import NoData from "../../NoData";
import Loading from "../../Loading";
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';

export default function () {

    DataTable.use(DT);
    const [contactDetails, setContactDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const adminToken = localStorage.getItem("authAdminToken");

    // Show Details Section
    const fetchAllContactDetails = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/getAllContacts`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${adminToken}`
            },
        });

        return response.json();
    };

    useEffect(() => {
        fetchAllContactDetails().then((res) => {
            if (res.status) {
                setContactDetails(res.contacts);
                setLoading(false);
            } else {
                toast.error("Unable to load contact details. Please try again later.");
            }
        }).catch((error) => {
            toast.error("Something went wrong! Please try again later.");
        });
    }, []);

    const theme = useSelector(selectMode);

    const themeColor = {
        color: theme === 'light' ? '#000' : '#fff',
        background: theme === 'light' ? '#fff' : 'rgb(203 204 225 / 20%)',
    };

    function formatIsoDate(isoDate) {
        // If timestamp is in seconds, convert to milliseconds
        const unixTime = new Date(isoDate).getTime()
        if (unixTime.toString().length === 10) {
            unixTime *= 1000;
        }

        const date = new Date(Number(unixTime));

        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "long" }); // "October"
        const year = date.getFullYear();

        return `${day} ${month} ${year}`;
    }

    return (
        <>
            {/* Toast container */}
            < ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {loading ?

                <Loading />
                :
                <div className="container-xxl flex-grow-1 container-p-y" style={{ margin: "4em 25em" }}>
                    <div className="card" style={themeColor}>
                        <div className="card-header ">
                            <h5 className="card-title mb-0" style={{ color: theme === 'light' ? '#000' : '#fff' }}>Contact Details</h5>
                        </div>

                        {contactDetails.length > 0 ?
                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <DataTable data={contactDetails.map((contact, index) => [index + 1, contact.name, contact.email, contact.message, formatIsoDate(contact.created_on)])} className="display">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Message</th>
                                                <th>Created Date</th>
                                            </tr>
                                        </thead>
                                    </DataTable>
                                </div>
                            </div>
                            :
                            <NoData />
                        }

                    </div>
                </div>

            }
        </>
    )
}
